<template>
  <div class="row condition-block">
    <div class="h2 text-center">{{ $t('conditionBlock.title') }}</div>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="condition-good"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('conditionBlock.good.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text">
              <p>
                {{ $t('conditionBlock.good.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <ul
      id="seasidetms_icon_list_items_v80addeibn"
      class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
    >
      <li
        id="seasidetms_icon_list_item_313kuc2855"
        class="seasidetms_icon_list_item shortcode_animated"
      >
        <div class="seasidetms_icon_list_item_inner">
          <div class="seasidetms_icon_list_icon_wrap">
            <span
              id="condition-ideal"
              class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
            ></span>
          </div>
          <div class="seasidetms_icon_list_item_content">
            <div class="h3 seasidetms_icon_list_item_title">
              {{ $t('conditionBlock.ideal.title') }}
            </div>
            <div class="seasidetms_icon_list_item_text">
              <p>
                {{ $t('conditionBlock.ideal.text') }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Condition',
}
</script>

<style>
.condition-block {
  padding-top: 10px;
  clear: both;
}
#condition-good::before {
  content: '' !important;
  background-image: url(/img/thumb-up-svgrepo-com.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
#condition-ideal::before {
  content: '' !important;
  background-image: url(/img/best-outline-red-svgrepo-com.svg);
  height: 55px;
  width: 55px;
  background-size: 55px;
  background-repeat: no-repeat;
  margin-top: 14px;
}
</style>
